import React, { useEffect, useRef, useState } from 'react';

/*
Test ohne 3D: 5555 5555 5555 4444 / 2029-09 / 123
Test ohne 3D: 5555 4444 3333 1111 / 2029-09 / 123


*/

const CONTAINER_ID = 'pfc-payment-form';

const PostFinanceForm = (props) => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [scriptReady, setScriptReady] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [formReady, setFormReady] = useState(false);
  const handlerRef = useRef(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = props.pics.url;
    script.onload = () => setScriptReady(true);
    script.onerror = () => setErrorMessage('Die Online-Zahlung konnte nicht geladen werden. Bitte versuche es später erneut.');
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [props.pics.url]);

  const selectMethod = (methodId) => () => {
    const handler = new window.IframeCheckoutHandler(methodId);
    handler.setValidationCallback((validationResult) => {
      if (validationResult && validationResult.success) {
        handler.submit();
      } else {
        setErrorMessage('Die Zahlung wurde abgebrochen oder ist fehlgeschlagen. Bitte überprüfe deine Angaben.');
      }
    });
    handler.create(CONTAINER_ID);
    handlerRef.current = handler;
    setSelectedMethod(methodId);
    setFormReady(true);
  };

  const handlePay = () => {
    if (!handlerRef.current) {
      setErrorMessage('Die Online-Zahlung konnte nicht geladen werden. Bitte versuche es später erneut.');
      return;
    }
    handlerRef.current.validate();
  };

  return (
    <div className="modal fade show" style={{display:"block",backgroundColor: "rgba(0,0,0,0.5)"}} >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Zahlung per Twint (alixon gmbh) / Kreditkarte</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={props.CloseModal}></button>
          </div>
          <div className="modal-body">
      {!selectedMethod &&
            <div>
              <p>Zahlungsmethode wählen:</p>
        {(props.pics.methods||[]).map(m => (
              <button key={m.id} className="btn btn-outline-secondary me-2 mb-2" disabled={!scriptReady} onClick={selectMethod(m.id)}>
          {m.image && <img src={m.image} alt={m.name} style={{height:'20px', marginRight:'6px'}} />}
                {m.name}
              </button>
        ))}
            </div>
      }
            <div id={CONTAINER_ID}></div>
      {selectedMethod &&
            <button className="btn btn-primary mt-3" disabled={!formReady} onClick={handlePay}>{"Jetzt CHF "+props.amount.toFixed(2)+" bezahlen"}</button>
      }
            {errorMessage && <div className="text-danger mt-3">{errorMessage}</div>}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PostFinanceForm;
